import type { IconData } from '@stacksjs/iconify-core'

export const ethernet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m385.128 118.178l-25.26 19.644l91.864 118.122l-91.919 118.236l25.263 19.64l107.192-137.88zm-265.314-.001L12.621 255.993l107.138 137.826l25.263-19.638l-91.866-118.182l91.918-118.176zM160 240h32v32h-32zm80 0h32v32h-32zm80 0h32v32h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ethernet
